var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex justify-center align-center",staticStyle:{"height":"100vh","background":"white"}})}
var staticRenderFns = []

export { render, staticRenderFns }